
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    actionClose: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    productQuantity: 1,
  }),
  computed: {
    ...mapGetters('cart', ['totalCartPrice', 'discountPrice', 'productCart']),
  },
  methods: {
    ...mapActions('cart', ['deleteCart']),
    isDeleteProduct(product) {
      this.deleteCart(product)
    },
    FinishPayment() {
      this.$router.push('/compra-pedido')
    },
  },
}
